import GuidePerformanceView from 'models/location/guide_performance_view';

export default class FilterGuidePerformance {
  constructor(context) {
    this.context = context;
  }

  run({ dateRange, guideCollectionId, interactionType }) {
    const currentLocation = this.context.stores.currentLocation.get();
    const currentSort = currentLocation instanceof GuidePerformanceView ? currentLocation.sort : undefined;

    this.context.router.navigateTo(
      GuidePerformanceView.create({ dateRange, guideCollectionId, interactionType, sort: currentSort })
    );
  }
}
